import React from 'react';

const rebrandingAlertCircleIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
    >
        <path
            d="M12.0448 7.59115V5.09115H9.54484V7.59115L9.96151 13.4245H11.6282L12.0448 7.59115Z"
            fill="white"
        />
        <path
            d="M12.0448 15.5078C12.0448 16.1982 11.4852 16.7578 10.7948 16.7578C10.1045 16.7578 9.54484 16.1982 9.54484 15.5078C9.54484 14.8175 10.1045 14.2578 10.7948 14.2578C11.4852 14.2578 12.0448 14.8175 12.0448 15.5078Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9615 10.9245C19.9615 15.9871 15.8574 20.0911 10.7948 20.0911C5.73223 20.0911 1.62817 15.9871 1.62817 10.9245C1.62817 5.86187 5.73223 1.75781 10.7948 1.75781C15.8574 1.75781 19.9615 5.86187 19.9615 10.9245ZM18.2948 10.9245C18.2948 15.0666 14.937 18.4245 10.7948 18.4245C6.6527 18.4245 3.29484 15.0666 3.29484 10.9245C3.29484 6.78234 6.6527 3.42448 10.7948 3.42448C14.937 3.42448 18.2948 6.78234 18.2948 10.9245Z"
            fill="white"
        />
    </svg>
);

export default rebrandingAlertCircleIcon;
